import { BaseModel } from 'sjs-base-model';

export default class FetchNamesakesModel extends BaseModel {

    constructor(data) {
        super();
        this.namesakes = [];
        this.update(data);
    }
}